export default {
  apiBaseUrl: process.env.VUE_APP_API_BASE_URL,
};
